import generateAction from 'common/modules/utils/generateAction'

const prefix = 'POPUPS_PROCESSOR/'

const set = generateAction({
    prefix,
    baseActionCreatorName: 'set',
    baseActionName: 'SET',
})

const run = generateAction({
    prefix,
    baseActionCreatorName: 'run',
    baseActionName: 'RUN',
})

const clear = generateAction({
    prefix,
    baseActionCreatorName: 'clear',
    baseActionName: 'CLEAR',
})

const types = {
    ...set.types,
    ...run.types,
    ...clear.types,
}

const creators = {
    ...set.creators(),
    ...run.creators(),
    ...clear.creators(),
}

export {
    types,
    creators,
    set,
    run,
    clear,
}
